import React from 'react';
import { useI18n } from 'next-localization';
import ArticleAuthor from './ArticleAuthor/ArticleAuthor';
import { ArticleData } from 'model/Article';

interface ArticleAuthorsProps {
  authors?: ArticleData['articleAuthor']['targetItems'];
  className?: string;
}

const ArticleAuthors: React.FC<ArticleAuthorsProps> = ({ authors, className }) => {
  const { t } = useI18n();

  const authorsLength = authors?.length;

  return (
    <div className={className}>
      <div className="footnote footnote--bold text-grey">
        {authorsLength === 1 ? t('author') : t('authors')}
      </div>

      <div className="mt-2">
        <div className="row mt-n2">
          {authors?.map((author) => (
            <div key={author.name.value} className="col-12 col-md-6 col-lg-12 mt-2">
              <ArticleAuthor author={author} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticleAuthors;
